import React from 'react';
import {
  InlineNotification,
  NotificationActionButton
} from 'carbon-components-react';

const DeleteWarning: React.FC<Props> = ({ onConfirm, onClose }) => {
  return (
    <div className="webhook-subscriptions-event-delete-warning">
      <InlineNotification
        lowContrast
        iconDescription="close"
        title="Unsubscribe?"
        subtitle="This action cannot be undone"
        kind="warning"
        actions={
          <NotificationActionButton onClick={() => onConfirm()}>
            {'Yes, unsubscribe'}
          </NotificationActionButton>
        }
        onCloseButtonClick={() => onClose()}
      />
    </div>
  );
};

type Props = {
  onConfirm: Function;
  onClose: Function;
};
export default React.memo(DeleteWarning);
